"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EformDtoToEformState = void 0;
var EformPropertyDtoToEformPropertyState_1 = require("@/pages/document/transformers/EformPropertyDtoToEformPropertyState");
var format_1 = require("@/utils/format");
exports.EformDtoToEformState = function (lang, email, titanUserId) {
    if (titanUserId === void 0) { titanUserId = 0; }
    return function (eformDto) {
        var _a;
        var isEn = lang.toLowerCase().indexOf('en') > -1;
        var documentPath = eformDto.documentKey;
        var signerMe = eformDto.signers.find(function (it) { return it.signingURL; });
        var status = (_a = signerMe === null || signerMe === void 0 ? void 0 : signerMe.signingStatus) !== null && _a !== void 0 ? _a : 1;
        var status_date = eformDto.signers.length > 0 ? eformDto.signers.map(function (it) { return new Date(it.updatedDate); }).sort().reverse()[0] : "";
        var signingUrl = documentPath ? "" : (signerMe ? signerMe === null || signerMe === void 0 ? void 0 : signerMe.signingURL : "");
        return {
            title: isEn ? eformDto.title : eformDto.titleChi,
            caption_1: isEn ? eformDto.caption : eformDto.captionChi,
            type: eformDto.documentTemplate,
            status: status,
            properties: eformDto.properties.map(EformPropertyDtoToEformPropertyState_1.EformPropertyDtoToEformPropertyState(lang)),
            status_date: status_date ? format_1.default.dateTime(status_date) : "",
            isExpanded: false,
            signingUrl: signingUrl,
            documentPath: documentPath
        };
    };
};
